//#region src/types.ts
let LogLevel = /* @__PURE__ */ function(LogLevel) {
	LogLevel["Debug"] = "debug";
	LogLevel["Info"] = "info";
	LogLevel["Log"] = "log";
	LogLevel["Warn"] = "warn";
	LogLevel["Error"] = "error";
	return LogLevel;
}({});
//#endregion
//#region src/util.ts
const enabledLogLevels = {
	["debug"]: [
		"debug",
		"info",
		"log",
		"warn",
		"error"
	],
	["info"]: [
		"info",
		"log",
		"warn",
		"error"
	],
	["log"]: [
		"log",
		"warn",
		"error"
	],
	["warn"]: ["warn", "error"],
	["error"]: ["error"]
};
function prepareMetadata(metadata) {
	const toSerializable = (value) => {
		if (value instanceof Error) return value.toString();
		if (value === null || value === void 0 || typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;
		if (Array.isArray(value)) return value.map((v) => toSerializable(v));
		if (typeof value === "object") {
			const result = {};
			for (const [k, v] of Object.entries(value)) result[k] = toSerializable(v);
			return result;
		}
		return String(value);
	};
	const prepared = {};
	for (const [key, value] of Object.entries(metadata)) prepared[key] = toSerializable(value);
	return prepared;
}
//#endregion
export { prepareMetadata as n, LogLevel as r, enabledLogLevels as t };

//# sourceMappingURL=util-ugZPQ7Ug.js.map